import { useEffect, useState } from "react";
import { useAuth } from "../../../../context/AuthContext";
import JobZImage from "../../../common/jobz-img";

const SOCIAL_KEY = "jobzilla_candidate_social";

function CanProfilePage() {
    const { user, updateProfile, uploadAvatar } = useAuth();
    const [form, setForm] = useState({ name: "", phone: "" });
    const [social, setSocial] = useState({ website: "", linkedin: "", github: "", portfolio: "" });
    const [message, setMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [avatarFile, setAvatarFile] = useState(null);

    useEffect(() => {
        setForm({ name: user?.name || "", phone: user?.phone || "" });
        const stored = localStorage.getItem(SOCIAL_KEY);
        if (stored) setSocial(JSON.parse(stored));
    }, [user]);

    const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });
    const updateSocial = (event) => setSocial({ ...social, [event.target.name]: event.target.value });
    const updateAvatar = (event) => setAvatarFile(event.target.files?.[0] || null);

    const submit = async (event) => {
        event.preventDefault();
        setSaving(true);
        setMessage("");
        try {
            await updateProfile(form);
            if (avatarFile) {
                await uploadAvatar(avatarFile);
                setAvatarFile(null);
            }
            localStorage.setItem(SOCIAL_KEY, JSON.stringify(social));
            setMessage("Candidate profile saved.");
        } catch (error) {
            setMessage(error.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="twm-right-section-panel site-bg-gray">
            <form onSubmit={submit}>
                <div className="panel panel-default">
                    <div className="panel-heading wt-panel-heading p-a20">
                        <h4 className="panel-tittle m-a0">Profile Image</h4>
                    </div>
                    <div className="panel-body wt-panel-body p-a20 m-b30">
                        <div className="dashboard-profile-pic">
                            <div className="dashboard-profile-photo">
                                <JobZImage src={user?.avatar_url || "images/user-avtar/pic4.jpg"} alt={user?.name || "Candidate"} />
                            </div>
                            <div className="form-group m-t20">
                                <label>Upload Profile Image</label>
                                <input className="form-control" type="file" accept="image/*" onChange={updateAvatar} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading wt-panel-heading p-a20">
                        <h4 className="panel-tittle m-a0">Basic Information</h4>
                    </div>
                    <div className="panel-body wt-panel-body p-a20 m-b30">
                        {message && <div className="alert alert-info">{message}</div>}
                        <div className="row">
                            <Field label="Full Name" name="name" value={form.name} onChange={update} required icon="fa fa-user" />
                            <Field label="Email Address" name="email" value={user?.email || ""} readOnly icon="fa fa-envelope" />
                            <Field label="Phone" name="phone" value={form.phone} onChange={update} icon="fa fa-phone-alt" />
                        </div>
                    </div>
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading wt-panel-heading p-a20">
                        <h4 className="panel-tittle m-a0">Social and Portfolio Links</h4>
                    </div>
                    <div className="panel-body wt-panel-body p-a20 m-b30">
                        <div className="row">
                            <Field label="Website" name="website" value={social.website} onChange={updateSocial} icon="fa fa-globe" />
                            <Field label="LinkedIn" name="linkedin" value={social.linkedin} onChange={updateSocial} icon="fab fa-linkedin-in" />
                            <Field label="GitHub" name="github" value={social.github} onChange={updateSocial} icon="fab fa-github" />
                            <Field label="Portfolio" name="portfolio" value={social.portfolio} onChange={updateSocial} icon="fa fa-briefcase" />
                            <div className="col-lg-12 col-md-12">
                                <button type="submit" className="site-button" disabled={saving}>{saving ? "Saving..." : "Save Changes"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

function Field({ label, name, value, onChange, icon, required = false, readOnly = false }) {
    return (
        <div className="col-xl-4 col-lg-6 col-md-12">
            <div className="form-group">
                <label>{label}</label>
                <div className="ls-inputicon-box">
                    <input className="form-control" name={name} type="text" required={required} readOnly={readOnly} value={value} onChange={onChange} placeholder={label} />
                    <i className={`fs-input-icon ${icon}`} />
                </div>
            </div>
        </div>
    );
}

export default CanProfilePage;
